// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__p5C_9"};